import './google-auth-button.css';
import { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '../../routes';
import { Spin } from '../spin';
import { auth, db, googleProvider } from '../../firebase';

const GoogleAuthButton = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const createUserProfile = async (uid: string, email: string) => {
    const response = await fetch(
      'https://europe-west3-imperialstonesgame.cloudfunctions.net/createUserProfile',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          uid,
          email,
        }),
      },
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.error || 'No se pudo crear perfil');
    }

    return data;
  };

  const checkUserProfile = async (uid: string): Promise<boolean> => {
    const ref = doc(db, 'users', uid);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      return false;
    }

    const data = snap.data();

    return Boolean(
      data.name &&
      data.lastName &&
      data.birthDate &&
      data.email &&
      data.referralCode,
    );
  };

  const handleGoogleAuth = async () => {
    try {
      setLoading(true);

      const res = await signInWithPopup(auth, googleProvider);

      const uid = res.user.uid;
      const email = res.user.email || '';

      const userRef = doc(db, 'users', uid);

      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        await createUserProfile(uid, email);
      }

      const profileCompleted = await checkUserProfile(uid);

      navigate(profileCompleted ? ROUTES.HOME : ROUTES.COMPLETE_PROFILE);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className="google-auth-button"
      onClick={handleGoogleAuth}
      disabled={loading}
      type="button"
    >
      <Spin spin={loading} size={20} className="isg-spin-floating" />
      <span className={loading ? 'loading' : ''}>Google</span>
    </button>
  );
};

export default GoogleAuthButton;
